import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";

export const requestRunMarketingFlows = async (): Promise<unknown> => {
  return await instance.post(ApiRoutesMarketing.FlowsRun);
};
